/**
 * Mask user name for privacy protection
 * Examples:
 * - "Jane" → "Ja**"
 * - "Jane Doe" → "Ja*** Do***"
 * - "Jane Doe Smith" → "Ja*** Do*** Sm***"
 * - "Jane Doe Smith Li" → "Ja*** Do*** Sm*** Li**"
 */
export function maskName(fullName: string): string {
  if (!fullName || fullName.trim() === '') {
    return 'Anonymous';
  }

  const words = fullName.trim().split(/\s+/);
  
  return words.map(word => {
    if (word.length <= 2) {
      // Very short words: show first letter only
      return word.charAt(0) + '*'.repeat(word.length - 1);
    } else if (word.length === 3) {
      // 3 letters: show first 2
      return word.substring(0, 2) + '*';
    } else if (word.length === 4) {
      // 4 letters: show first 2
      return word.substring(0, 2) + '**';
    } else {
      // 5+ letters: show first 2, mask the rest
      const visibleChars = 2;
      const maskedLength = Math.min(word.length - visibleChars, 3); // Max 3 asterisks
      return word.substring(0, visibleChars) + '*'.repeat(maskedLength);
    }
  }).join(' ');
}

/**
 * Examples for testing:
 * maskName("Jane") → "Ja**"
 * maskName("Jane Doe") → "Ja** Do**"
 * maskName("John Smith") → "Jo*** Sm***"
 * maskName("Jane Doe Smith") → "Ja** Do** Sm***"
 * maskName("A") → "A"
 * maskName("Ab") → "A*"
 * maskName("") → "Anonymous"
 */
